import getBaseUrl from "./getBaseUrl";

const getSubscribeButtonLink = (user) => {
    if (!user || !user.type) return `${getBaseUrl()}/register`;

    return `${getBaseUrl()}/pricing`;
};

export default getSubscribeButtonLink;
